import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { useForm, useAuth } from '~/hooks';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { Card, Portal } from '~/components';
import FormGroup from '~/components/form/form-group';
import FormPassword from '~/components/form/form-password';
import FormError from '~/components/form/form-error';
import Checkbox from '~/components/form/form-control-checkbox';
import TryonExpressLogo from '~/assets/img/tryonexpress-logo.png';
import { MdCall, MdMailOutline } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { getItem, removeItem, setItem } from '~/util/storage';

const LoginPage = () => {

    const authContext = useAuth();
    const history = useHistory();

    const [isLoginInProgress, setLoginStatus] = useState(false);

    const onSubmit = async ({ values, onFail, onInvalidForm, resetFormErrors }) => {
        setLoginStatus(true);
        let errors = {};
        try {
            resetFormErrors();
            if (!values.username) errors.username = 'Username is required';
            if (!values.password) errors.password = 'Password is required';
            if (!isEmpty(errors)) return onInvalidForm(errors);

            if(values.rememberMe){
                setItem('username', values.username); 
                setItem('rememberMe', values.rememberMe);     
            }else{
                removeItem('username');
                removeItem('rememberMe');
            }
            await authContext.login(values.username, values.password);

            history.push('/');
            
        } catch (e) {
            errors.formError = e.message;
            if (!isEmpty(errors)) return onInvalidForm(errors);
            return onFail(e.message);
        }
    };

    const {
        state,
        formActions,
        fieldActions
    } = useForm({
        initialState: {
            username: getItem('username') || '',
            password: '',
            rememberMe: getItem('rememberMe')
        },
        onSubmit
    });

    return (
        <div className="h-screen w-screen bg-gradient-to-b from-blue-50 to-blue-60 flex flex-col items-center justify-center p-8 md:p-12 lg:px-10 lg:py-36">
            <Card className="h-screen flex-1 flex flex-col lg:flex-row-reverse items-stretch w-11/12 lg:w-5/6 xl:w-2/3 justify-items-stretch">
                <div className="bg-login flex-1 lg:flex-initial lg:w-1/2 bg-center bg-no-repeat bg-cover"/> 
                <section className="flex-grow lg:w-1/2 flex flex-col items-stretch justify-center p-8 lg:p-16">
                    { isLoginInProgress && 
                    <Portal id="loading-modal">
                        <div className="flex items-center justify-center h-screen w-screen  bg-gray-400 opacity-70 z-50 fixed top-0">
                            <AiOutlineLoading3Quarters className="animate-spin text-blue-30 font-bold" size="4rem" />
                        </div>
                    </Portal>
                    }
                    <img src={TryonExpressLogo} className="h-16 self-start mb-4 ml-1"/>
                    <p className="font-semibold text-sm lg:text-base xl:text-lg mb-1">Residential &amp; Commercial Title Service Company</p>
                    <p className="text-gray-410 text-xs lg:text-sm mb-4">From Mountain to Coast, Serving all 100 North Carolina Counties</p>
                    <p className="text-sm font-semibold mb-2">Login</p>
                    <FormError value={state.formError} />
                    <FormGroup 
                        placeholder="Username"
                        path="username"
                        inputClassName="w-full text-sm lg:text-base border-1 border-gray-200 rounded bg-gray-50"
                        value={state.values.username}
                        error={state.errors.username}
                        {...fieldActions}
                    />
                    <FormPassword 
                        placeholder="Password"
                        type="password"
                        path="password"
                        inputClassName="w-full text-sm lg:text-base border-1 border-gray-200 rounded bg-gray-50"
                        value={state.values.password}
                        error={state.errors.password}
                        onSubmitAction={formActions.submit}
                        {...fieldActions}
                    />
                    <FormError value={state.errors.formError} />
                    <Checkbox 
                        label="Remember Me"
                        path="rememberMe"
                        groupClassName="flex items-center text-xs lg:text-sm align-center mt-2"
                        inputClassName="border-1 border-gray-200 text-xs lg:text-sm rounded bg-white mr-2"
                        value={state.values.rememberMe} {...fieldActions} />
                    <div className="flex flex-col md:flex-row items-start md:items-center mt-4">
                        <button className="py-2 px-4 rounded-full text-white text-xs lg:text-sm bg-blue-50 font-semibold" onClick={() => formActions.submit()}>Login</button>
                        <Link to="/register" className="mt-2 md:mt-0 md:ml-3 py-2 px-4 rounded-full text-blueGray-100 text-xs lg:text-sm bg-gray-100 font-semibold">
                            Create&nbsp;Account
                        </Link>
                    </div>
                    <p className="text-xs lg:text-sm mt-4 md:mt-8">Open M-F 8:00 AM to 8:00 PM, Saturday 9:00 AM to 1:00 PM</p>
                    <div className="flex items-center text-gray-400 text-xs lg:text-sm mt-1">
                        <a href='tel:9192770123' className="flex items-center mr-4">
                            <MdCall size="1.125rem" className="mr-1"/>
                            (919) 277-0123
                        </a>
                        <a href='mailto:orders@tryontitle.com' className="flex items-center">
                            <MdMailOutline size="1.125rem" className="mr-1"/>
                            orders@tryontitle.com
                        </a>
                    </div>
                </section>
            </Card>
        </div>
    );
};

export default LoginPage;